export default __webpack_public_path__ + "static/media/IMG_4610_2.bd382b34.jpg";